export * from './dialog-yes-no-cancel.component';



// WEBPACK FOOTER //
// ./src/app/modules/shared/component/dialog-yes-no-cancel/index.ts